module.exports = __webpack_public_path__ + "static/media/logoHSEnterprise.a1acac33.png";